import { IApiService } from "../../store";

export interface AsyncQueriesParams {
  api: IApiService;
}

export class AsyncQueries {
  protected readonly api: IApiService;
  constructor({ api }: AsyncQueriesParams) {
    this.api = api;
  }
}
